import CafeteriaMenuManagementTable from './lib/table';
import Gap from 'components/gap';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import AppLoading from 'components/appLoading';
import SecundButton from 'components/form/buttons/secundButton';
import { useNavigate } from 'react-router';

import * as S from './styles';

export default function CafeteriaMenuManagementPage() {
  // -- //
  const { menuList, createMenu, editMenu, upload }: any = useTypedSelector((state) => state.Cafeteria);

  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate('/panel/cafeteria/menu-management/create');
  };

  return (
    <S.Container>
      <S.Head>
        <S.Title>Menu Management</S.Title>
        <SecundButton hasIcon={true} onClick={handleRedirect}>
          Create new item
        </SecundButton>
      </S.Head>
      <Gap size="20px" />
      <CafeteriaMenuManagementTable menuList={menuList.data} loading={menuList.loading} />

      <AppLoading loading={createMenu.loading || editMenu.loading || upload.loading} />
    </S.Container>
  );
}
